import { useListConnections } from '~/features/onboarding/hooks/use-connections';
import { buildLocaleDestinationRows } from '~/features/onboarding/utils/gmc-locale-destinations';

/**
 * The translated locales the tenant's Google Merchant Center connection can actually deliver:
 * the `config.locale_destinations` entries with both a feed label and a data source (the same
 * rule delivery's `locale_destination()` applies). The connection is the source of truth, so the
 * enrichment Languages pickers offer only these; anything else would enrich and never ship.
 * One GMC connection per tenant (the backend enforces it). Shares the app-wide connections list
 * query, so it adds no request where that list is already cached.
 */
export function useConnectionDeliveryLocales() {
  const connections = useListConnections();
  const gmc = (connections.data ?? []).find((c) => c.type === 'GOOGLE_MERCHANT');
  const codes = buildLocaleDestinationRows(gmc?.config)
    .filter((row) => row.feedLabel.trim() && row.datasourceId.trim())
    .map((row) => row.locale);

  return {
    /** Deliverable locale codes, as stored on the connection (e.g. `['es-ES']`). */
    codes,
    /** The GMC connection, for linking to its settings; `undefined` when there is none. */
    connectionId: gmc?.id,
    isPending: connections.isPending,
    /** The list has loaded, so an empty `codes` means "none enabled", not "unknown". */
    connectionsLoaded: connections.isSuccess,
    isError: connections.isError,
  };
}
